import Api from './Api';

const all = (payload) => {
    const path = '/task-schedulers';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const getByOne = (payload) => {
    const path = '/task-scheduler/find-by-one';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;
    return Api.getRequest({
        endpoint
    });
};


const store = (payload) => {
    return Api.postRequest({
        endpoint: '/task-scheduler/store',
        data: payload
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/task-scheduler/update',
        method: 'PUT',
        data: payload
    });
};

const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/task-scheduler/destroy/${payload.id}`,
    });
};

const softDelete = (payload) => {
    return Api.deleteRequest({
        endpoint: `/task-scheduler/soft-delete/${payload.id}`,
    });
};

export default {
    all,
    store,
    update,
    destroy,
    softDelete,
    getByOne
};